import { useNavigate } from 'react-router-dom';
import { ARCHIVE_ENTRIES_WORDING } from '@lib/care-model';

/**
 * R. 82 / row 401: nav 08 (Archive) holds two views, each its own URL so a link lands on the right
 * one and the side menu highlights 08 for both (`activeIdFor` matches on the /archive prefix):
 *   /archive          the review bundles (every package sent to the Portal)
 *   /archive/entries  the closed entries (every entry in a terminal status, from member_care.db)
 * The same chip strip the Exceptions screens use for their two views (DncMaster.tsx ViewSwitch).
 */
export type ArchiveView = 'bundles' | 'entries';

export const ARCHIVE_PATHS: Record<ArchiveView, string> = { bundles: '/archive', entries: '/archive/entries' };

export function ArchiveTabs({ active }: { active: ArchiveView }): JSX.Element {
  const navigate = useNavigate();
  const tab = (view: ArchiveView, label: string) => (
    <button
      type="button"
      role="tab"
      aria-selected={active === view}
      className={active === view ? 'chip selected' : 'chip'}
      onClick={() => { if (active !== view) navigate(ARCHIVE_PATHS[view]); }}
    >
      {label}
    </button>
  );
  return (
    <div style={{ display: 'flex', gap: 6, marginBottom: 12 }} role="tablist" aria-label="Archive view">
      {tab('bundles', ARCHIVE_ENTRIES_WORDING.tabBundles)}
      {tab('entries', ARCHIVE_ENTRIES_WORDING.tabEntries)}
    </div>
  );
}
